import { makeAutoObservable } from "mobx";

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import {
  deleteClientAwardType,
  getClientAwardTypeId,
  pagingClientAwardType,
  saveOrUpdateClientAwardType,
} from "app/services/ClientAwardType";
import { checkSearchObject } from "app/common/LocalFunction";
import {
  getFileById,
  uploadFile,
} from "app/services/FileDescriptionExtService";

const defaultValue = {
  code: "",
  name: "",
  description: "",
  unit: "",
  quantity: 0,
  systemCalculating: true,
};
export default class ClientAwardTypeStore {
  searchObj = new SearchObject();
  pageObj = null;
  openFormCreateOrEdit = false;
  openConfirmDelete = false;
  selectedObj = defaultValue;
  selectedFile = null;

  constructor() {
    makeAutoObservable(this);
  }
  pagingObj = async () => {
    return await pagingClientAwardType(this.searchObj)
      .then(({ data }) => {
        this.pageObj = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu hạng tích điểm có lỗi");
      });
  };
  handleOpenFormCreateOrEdit = (PointRank) => {
    if (Boolean(PointRank)) {
      getClientAwardTypeId(PointRank).then(async ({ data }) => {
        if (data?.iconDescription && data?.iconDescription?.id) {
          let dataId = await this.handleGetFileDescription(
            data?.iconDescription?.id
          );
          if (dataId instanceof Blob) {
            const fileInfoResponses = {
              src: URL.createObjectURL(dataId),
              name: data?.iconDescription?.name,
              id: data?.iconDescription?.id,
            };
            this.selectedFile = fileInfoResponses;
          }
        }
        this.selectedObj = data;
        this.openFormCreateOrEdit = true;
      });
      this.pagingObj();
    } else {
      this.selectedObj = { ...defaultValue };
      this.openFormCreateOrEdit = true;
    }
  };

  handleCloseOpenFormCreateOrEdit = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDelete = false;
    this.selectedFile = null;
  };

  saveOrUpdateObj = (obj, { setSubmitting }) => {
    const iconDescription = {
      id: this.selectedFile?.id,
    };
    saveOrUpdateClientAwardType({ ...obj, iconDescription })
      .then(() => {
        this.selectedObj = defaultValue;
        toast.success("Lưu thông tin thành công!");
        this.handleCloseOpenFormCreateOrEdit();
        this.pagingObj();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin có lỗi");
      })
      .finally(() => setSubmitting(false));
  };
  handleDelete = (PointRank) => {
    this.selectedObj = { id: PointRank?.id };
    this.openConfirmDelete = true;
  };

  handleConfirmDelete = async () => {
    return await deleteClientAwardType(this.selectedObj?.id)
      .then(() => {
        if (
          this.searchObj?.pageIndex > 1 &&
          this.pageObj?.content?.length === 1
        ) {
          this.searchObj.pageIndex -= 1;
        }
        toast.success("Xóa hạng tích điểm thành công!");
        this.handleCloseOpenFormCreateOrEdit();
        this.pagingObj();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Xóa hạng tích điểm có lỗi");
      });
  };

  handleChangeFormSearch = (searchObj) => {
    this.searchObj = checkSearchObject(this.searchObj, searchObj);
    // console.log("Gửi API với searchObj:", this.searchObj);
    this.pagingObj();
  };

  setSelectedFile = (img) => {
    this.selectedFile = img;
  };

  handleGetFileDescription = async (id) => {
    try {
      const { data } = await getFileById(id);
      return data;
    } catch (error) {
      toast.error(error);
    }
  };
  handleUpload = async (file) => {
    try {
      const { data } = await uploadFile(file);
      let fileInfoResponses;
      if (data) {
        let dataId = await this.handleGetFileDescription(data?.id);
        if (dataId instanceof Blob) {
          fileInfoResponses = {
            src: URL.createObjectURL(dataId),
            name: data?.name,
            id: data?.id,
          };
        }
      }

      return fileInfoResponses;
    } catch (err) {
      console.error("Lỗi trong quá trình upload ảnh:", err);
    }
  };

  resetStore = () => {
    this.searchObj = new SearchObject();
    this.pageObj = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDelete = false;
  };
}
